import React, {useContext} from 'react';
import {Context} from '../../context';

function MigrationHeader(props) {
  const {localeText} = useContext(Context);
  return (
    <div className='flex justify-center gap-10 mt-10 mb-20'>
      <img
        alt={`${localeText(
          'rw_alt_old_transit_card_img',
          'Old transit account card image'
        )}`}
        src='/images/suncard-old.png'
        className='h-40 rounded-lg hidden lg:block'
      />
      <div className='flex flex-col justify-between w-96 pt-6'>
        <div className="h-12 bg-[url('/public/images/migration-arrow.png')] bg-contain bg-no-repeat flex items-center justify-center text-3xl pr-10">
          {localeText('rw_header_system_migration', 'System Migration')}
        </div>
        <p>{props.guidanceText}</p>
      </div>
      <div className='hidden lg:block relative'>
        <img
          alt={`${localeText(
            'rw_alt_transit_card_img',
            'Transit account card image'
          )}`}
          src='/images/suncard.png'
          className='h-40 rounded-lg relative'
        />
        <img
          alt={localeText('rw_alt_phone', 'General phone image')}
          src='/images/general_phone_image.png'
          className='h-64 rounded-lg mt-5 absolute -right-20 -top-14 -z-10'
        />
      </div>
    </div>
  );
}

export default MigrationHeader;
